import { jsx as _jsx } from "react/jsx-runtime";
import { SelectableBoxGroup } from '../../SelectableBox/index.js';
export default function SelectableImageGroup(props) {
    return (_jsx(SelectableBoxGroup, { spacing: "compactSquare", inputPlacement: props.inputPlacement || 'floating', ...props, children: props.children }));
}
//# sourceMappingURL=SelectableImageGroup.js.map